import { pageDefinition } from 'site-modules/shared/pages/page';
import { EdmundsLandingDecorator } from 'site-modules/shared/pages/decorators/edmunds-landing-decorator';
import { decoratorParams } from 'site-modules/shared/pages/decorators/decorator-params';
import { pageOptions } from './canvas-definition';
import { Canvas } from './canvas-desktop';

export default pageDefinition({
  ...pageOptions,
  component: Canvas,
  decorator: decoratorParams(EdmundsLandingDecorator, {
    skipFooter: true,
    className: 'canvas-desktop-page',
  }),
  chunkName: 'chat_canvas_desktop',
});
